import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Row, Col, Card } from 'react-bootstrap';

const NoPermissions = () => {
  return (
    <>
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
      <title>Access Required - Elliot Koss</title>
    </Helmet>
    <div style={{
      background: 'linear-gradient(135deg, rgba(232, 232, 232, 0.92) 0%, rgba(248,250,252,0.95) 100%)',
      minHeight: '100vh',
      padding: '120px 60px 0px 60px',
      margin: '0',
      width: '100%'
    }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} md={10}>
            <Card style={{
              border: 'none',
              borderRadius: '16px',
              boxShadow: '0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
              background: 'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(248,250,252,0.9) 100%)'
            }}>
              <Card.Body className="text-center" style={{ padding: '3rem' }}>
                <h1 style={{
                  fontSize: '2.5rem',
                  fontWeight: '300',
                  color: '#2d3748',
                  marginBottom: '1.5rem',
                  fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
                }}>
                  Access Required
                </h1>
                <p style={{
                  fontSize: '1.1rem',
                  color: '#4a5568',
                  lineHeight: '1.6',
                  marginBottom: '0',
                  fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
                }}>
                  You don't have permission to access this area. Please contact Elliot via email or{' '}
                  <a 
                    href="/contact" 
                    style={{ color: '#667eea', textDecoration: 'none' }}
                  >
                    contact form
                  </a>
                  {' '}to request access.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
    </>
  );
};

export default NoPermissions;
